// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "01040ba",
    "hash": "01040ba",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "01040ba",
    "semverString": null,
    "version": "10.0.0",
    "date": "2026-11-04T04:51:43.845Z"
};
/* tslint:enable */
